import React, { useState } from 'react';
import PropTypes from 'prop-types';
import * as colors from '../../styles/colors'

const InfoCollapse = ({title,body, styles}) => {

    const [isOpened, setOpened] = useState(false);
    return (
        <div style={{ borderBottom: '1px solid #cacaca',padding: '5px 0',marginBottom: '10px', width: '100%' }}>
            <div style={{cursor: 'pointer'}} onClick={() => setOpened(state => !state)}> {title} </div>
            {isOpened && <div style={{whiteSpace: 'pre-line',...styles}}> {body} </div> }
        </div>
    )
};

InfoCollapse.defaultProps = {
    title: '',
    body: '',
    styles: {}
}

InfoCollapse.propTypes = {
    title: PropTypes.string.isRequired,
    body: PropTypes.string,
    styles: PropTypes.object
}

export default React.memo(InfoCollapse);